<template>
	<form-sidebar>
		<header>
			<h2>
				¿Está seguro que desea eliminar el dato "{{ name }}"?
			</h2>
		</header>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="submitForm"
			>
			</modal-sidebar-button>
		</section>
	</form-sidebar>
</template>

<script>

async function submitForm() {
	try {
		await this.$http.delete(`data-dictionary/${this.id}`);
		this.$emit('close-modal', true);
		this.showNotification('Dato eliminado correctamente');
	} catch (error) {
		this.showGenericError();
	}
}

export default {
	name: 'dictionary-remove',
	methods: {
		submitForm,
	},
	props: {
		id: {
			type: Number,
			default: null,
		},
		name: {
			type: String,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/dictionary/dictionary-form-remove.vue